import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { InAppTemplate } from "../../../shared/templates/inapp";
import { LightspeedIntegrationPage } from "./lightspeed";
import "./integrations.scss";

const IntegrationsPage = () => {
  return (
    <InAppTemplate
      pageHeadingTitle="Integrations"
      childComponent={<IntegrationsContent />}
    />
  );
};

const IntegrationsContent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("code") && params.get("state")) {
      navigate(`/app/integrations/lightspeed${location.search}`, {
        replace: true,
      });
    }
  }, [location.search, navigate]);

  return (
    <div className="integrations-page">
      <div className="page-content cards">
        <div className="integrations-header">
          <h3>Available Integrations</h3>
          <p>
            Connect your store with external services to streamline your
            operations.
          </p>
        </div>

        {/* Active Integrations */}
        <div className="active-integrations">
          <div className="integration-card active">
            <div className="integration-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="8" fill="#0066CC" />
                <path d="M12 16h24v16H12V16z" fill="white" />
                <path
                  d="M16 20h16v2H16v-2zm0 4h12v2H16v-2zm0 4h8v2H16v-2z"
                  fill="#0066CC"
                />
              </svg>
            </div>
            <div className="integration-info">
              <h4>Lightspeed Retail</h4>
              <p>
                Sync your inventory, orders, and customer data with Lightspeed
                POS system.
              </p>
            </div>
            <div className="integration-status">
              <span className="status-badge connected">Connected</span>
            </div>
          </div>
        </div>
      </div>

      {/* Lightspeed Integration Details */}
      <LightspeedIntegrationPage />
    </div>
  );
};

export default IntegrationsPage;
